import api from '../../../shared/utils/api';

const rolesApi = {
  getUserRoles: (userId) => api.get(`/api/roles/user/${userId}`),
  assignRole: (userId, participantType) => api.post('/api/roles/assign', { userId, participantType }),
  removeRole: (userId, participantType) => api.delete(`/api/roles/${userId}/${participantType}`),
  setActiveRole: (participantType) => api.put('/api/roles/active', { participantType }),

  // The organisation's stage-access policy. Readable by any member — the
  // workflow UI needs it to explain a disabled control — but admin-only to
  // change, like every other privilege decision.
  getAccessPolicy: () => api.get('/api/roles/access-policy'),
  setAccessPolicy: (stageAccessMode) => api.patch('/api/roles/access-policy', { stageAccessMode }),
};

export default rolesApi;
